$(document).ready(function () {
    var counterElement = $('#number_counter');
    var dataItems = $('.counter_real_time').data('items').split(',').map(Number);
    var intervalTime = $('.counter_real_time').data('interval-time');
    var currentIndex = 0;

    // Function to shuffle array elements
    function shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }

    // Update the counter with the next random value
    function updateCounter() {
        currentIndex = (currentIndex + 1) % dataItems.length;
        counterElement.find('span').text(dataItems[currentIndex]);
    }

    // Shuffle the dataItems array initially
    dataItems = shuffleArray(dataItems);

    // Update the counter initially
    updateCounter();

    // Set interval for updating counter
    setInterval(updateCounter, intervalTime);
});